import React from 'react'
import refundconfirmationStyle from './RefundConfirmationPage.module.css'
import mainLogo from '../../../assets/images/logo-new-green.webp'
import BackBar from '../../components/BackBar/BackBar';

export default function RefundConfirmationPage() {
  return (
    <>
      <div className={refundconfirmationStyle.orderconmain} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row justify-content-center'>
            <div className="col-lg-11">
              <div className={refundconfirmationStyle.orderconmainBody}>
                <div className={refundconfirmationStyle.orderconhead}>
                  <div className="row">
                    <div className="col-xl-6">
                      <img src={mainLogo} className={`${refundconfirmationStyle.imglogo}`} />
                    </div>
                    <div className="col-xl-6">
                      <div className={`${refundconfirmationStyle.orderheadtitles} text-end`}>
                        <h4>Refund Confirmation</h4>
                        <p>Author Book Signing</p>
                        <p>Order ID: 18036</p>
                        <p>School Name: Demo Elementary School</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={refundconfirmationStyle.ordershipbox}>
                  <div className="row">
                    <div className="col-xl-6">
                      <div className={`${refundconfirmationStyle.ordershipboxleft} text-start`}>
                        <h4>Date: June 3, 2024</h4>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className={`${refundconfirmationStyle.ordershipboxright} text-end`}>
                        <h4>Parents Information:</h4>
                        <p>Sunil Bajaj</p>
                        <p>email@email.com</p>
                        <p>123-456-7890</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={refundconfirmationStyle.ordertblbox}>
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="table-responsive">
                        <table className={`${refundconfirmationStyle.orderconfirmTable} table`}>
                          <thead>
                            <tr>
                              <th>Order List:</th>
                              <th className='text-center'>Requested Quantity</th>
                              <th className='text-center'>Order List:</th>
                              <th className='text-end'>Refund Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <div>The Enchanted Forest</div>
                                <div>ISBN: 9780316493796</div>
                              </td>
                              <td className='text-center' valign='middle'>Qty 1</td>
                              <td className='text-center' valign='middle'>$0.00</td>
                              <td className='text-end' valign='middle'>$0.00</td>
                            </tr>
                            <tr>
                              <td>
                                <div>The Enchanted Forest</div>
                                <div>ISBN: 9780316493796</div>
                              </td>
                              <td className='text-center' valign='middle'>Qty 1</td>
                              <td className='text-center' valign='middle'>$0.00</td>
                              <td className='text-end' valign='middle'>$0.00</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xl-6'></div>
                    <div className='col-xl-3'>
                      <div className="table-responsive">
                        <table className={`${refundconfirmationStyle.refundtotlTable} table`}>
                          <tbody>
                            <tr>
                              <th className='text-end'>Total</th>
                              <td className='text-end'>$0.00</td>
                            </tr>
                            <tr>
                              <th className='text-end'>Tax</th>
                              <td className='text-end'>$0.00</td>
                            </tr>
                            <tr>
                              <th className='text-end'>Grand Total</th>
                              <td className='text-end'>$0.00</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className='col-xl-3'>
                      <div className="table-responsive">
                        <table className={`${refundconfirmationStyle.refundtotlTable} table`}>
                          <tbody>
                            <tr>
                              <th className='text-end'>Refund Total</th>
                              <td className='text-end'>$0.00</td>
                            </tr>
                            <tr>
                              <th className='text-end'>Refund Tax</th>
                              <td className='text-end'>$0.00</td>
                            </tr>
                            <tr>
                              <th className='text-end'>Refund Grand Total</th>
                              <td className='text-end'>$0.00</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={refundconfirmationStyle.orderfooterbox}>
                  <div className="row">
                    <div className="col-xl-12 text-center">
                      <h6>Bookworm Central | 12193 Livingston Road Manassas, VA 20109 | Email: info@bookwormcentral.com</h6>
                      <h5>Love books? Follow us:</h5>
                    </div>
                    <div className='col-xl-12 text-center'>
                      <div className={refundconfirmationStyle.socialbar}>
                        <a href="#" className={refundconfirmationStyle.fb}>
                          <i class="bi bi-facebook"></i>
                        </a>
                        <a href="#" className={refundconfirmationStyle.ig}>
                          <i className="fa fa-instagram"></i>
                        </a>
                        <a href="#" className={refundconfirmationStyle.in}>
                          <i className="fa fa-linkedin-in"></i>
                        </a>
                        <a href="#" className={refundconfirmationStyle.tw}>
                          <i className="fa fa-twitter"></i>
                        </a>
                        <a href="#" className={refundconfirmationStyle.pt}>
                          <i className="fa fa-pinterest-p"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
